{
  "CHAT_LIST": {
    "LOADING": "Λήψη συζητήσεων",
    "LOAD_MORE_CONVERSATIONS": "Φόρτωση περισσότερων συζητήσεων",
    "EOF": "Όλες οι συζητήσεις φορτώθηκαν 🎉",
    "LIST": {
      "404": "Δεν υπάρχουν ενεργές συζητήσεις σε αυτήν την ομάδα."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Συζητήσεις",
    "MENTION_HEADING": "Αναφορές",
    "UNATTENDED_HEADING": "Χωρίς Παρακολούθηση",
    "SEARCH": {
      "INPUT": "Αναζήτηση Ανθρώπων, συνομιλιών, αποθηκευμένων απαντήσεων .."
    },
    "FILTER_ALL": "Όλες",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Δικές μου",
      "unassigned": "Χωρίς Αντιστοίχιση",
      "all": "Όλες"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Ανοιχτές"
      },
      "resolved": {
        "TEXT": "Επιλύθηκαν"
      },
      "pending": {
        "TEXT": "Εκκρεμεί"
      },
      "snoozed": {
        "TEXT": "Αναβολή"
      },
      "all": {
        "TEXT": "Όλες"
      }
    },
    "VIEW_FILTER": "Προβολή",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "Κατάσταση",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Created",
        "OLDEST": "Δημιουργήθηκε στις:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Last activity:",
        "ACTIVE": "Last activity"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      },
      "unread": {
        "TEXT": "Unread Count: Highest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Μήνυμα εικόνας"
      },
      "audio": {
        "CONTENT": "Μήνυμα ήχου"
      },
      "video": {
        "CONTENT": "Μήνυμα βίντεο"
      },
      "file": {
        "CONTENT": "Επισυναπτόμενο αρχείο"
      },
      "location": {
        "CONTENT": "Θέση"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "έχει μοιράσει ένα σύνδεσμο"
      },
      "contact": {
        "CONTENT": "Shared contact"
      },
      "embed": {
        "CONTENT": "Embedded content"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Ταξινόμηση κατά",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Δημιουργήθηκε στις",
          "LABEL": "Δημιουργήθηκε στις"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Παραλήφθηκε από email",
    "VIEW_TWEET_IN_TWITTER": "Προβολή του tweet στο Twitter",
    "REPLY_TO_TWEET": "Απάντηση στο tweet",
    "LINK_TO_STORY": "Μετάβαση στην ιστορία instagram",
    "SENT": "Επιτυχής αποστολή",
    "READ": "Διαβάστηκε με επιτυχία",
    "DELIVERED": "Παραδόθηκε με επιτυχία",
    "NO_MESSAGES": "Κανένα Μήνυμα",
    "NO_CONTENT": "Μη διαθέσιμο περιεχόμενο",
    "HIDE_QUOTED_TEXT": "Απόκρυψη Κειμένου Παράθεσης",
    "SHOW_QUOTED_TEXT": "Απόκρυψη Κειμένου Παράθεσης",
    "MESSAGE_READ": "Ανάγνωση",
    "SENDING": "Sending",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
